import resume from "../../assets/Teo_Yu_Qi Resume.pdf";

const CallToAction = () => {
  return (
    <div className="call-to-action">
      <a
        href={resume}
        download="Teo_Yu_Qi resume.pdf"
        className="btn"
      >
        Download resume
      </a>
      <a
        href="#contact"
        className="btn btn-primary"
      >
        Contact me
      </a>
    </div>
  );
};

export default CallToAction;
